export interface SigninRequest {
  email: string;
  password: string;
  token?: string;
}

export interface ForgotPasswordRequest {
  email: string;
  token?: string;
}

export interface ResetPasswordRequest {
  reset_token: string;
  new_password: string;
  confirm_password: string;
  token?: string;
}

export interface VerifyEmailRequest {
  token: string;
}

export interface ChangePasswordRequest {
  old_password: string;
  password: string;
  confirm_password: string;
  token?: string;
}

export interface SigninResponse {
  access?: string;
  user_id?: number;
  message: string;
  refresh?: string;
  role?: UserRole;
  success?: boolean;
  tenant_id?: number | null;
  tenant_slug?: string | null;
  org_id?: number | null;
  is_platform_admin?: boolean;
}

export interface AzureConfigResponse {
  enabled: boolean;
}

export interface AzureStartRequest {
  redirect_uri: string;
}

export interface AzureStartResponse {
  authorize_url: string;
  state: string;
}

/** The single-use authorization code and the `state` it was issued for. */
export interface AzureLoginRequest {
  code: string;
  state: string;
}

export interface AzureLoginResponse {
  success?: boolean;
  message: string;
  refresh?: string;
  access?: string;
  user_id?: number;
  role?: UserRole;
  tenant_id?: number | null;
  tenant_slug?: string | null;
  org_id?: number | null;
  is_platform_admin?: boolean;
  data?: {
    refresh?: string;
    access?: string;
    user_id?: number;
    role?: string;
    tenant_id?: number | null;
    tenant_slug?: string | null;
    org_id?: number | null;
    is_platform_admin?: boolean;
  };
}

export interface AuthSessionPayload {
  authenticated: boolean;
  user_id?: number | null;
  role?: UserRole | string | null;
  tenant_id?: number | null;
  tenant_slug?: string | null;
  org_id?: number | null;
  is_platform_admin?: boolean;
  /** Server-computed UI capabilities (backend `authz.capabilities_for`). */
  capabilities?: {
    edit_departments?: boolean;
    view_admin_console?: boolean;
    view_record_owners?: boolean;
    platform_admin?: boolean;
  } | null;
}

export interface AuthSessionResponse {
  success: boolean;
  message: string;
  data: AuthSessionPayload;
}

export enum UserRole {
  ORG_ADMIN = 'org_admin',
  DEPT_ADMIN = 'dept_admin',
  USER = 'user'
}

export interface SignupRequest {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  confirm_password: string;
  tos_accepted: boolean;
  turnstile_token?: string;
  token?: string;
}

export interface AuthActionResponse {
  message: string;
  success?: boolean;
  data?: Record<string, unknown>;
}
